import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { StaffService } from "..";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { StaffInsertModel } from "../shared/StaffInsertModel";
// import { StaffRequestModel } from '../shared/StaffRequestModel';
import * as moment from "moment";

@Component({
	selector: "app-add-staff",
	templateUrl: "./add-staff.component.html",
	styleUrls: ["./add-staff.component.css"],
})
export class AddStaffComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private staffService: StaffService,
		private userService: UserService,
		private schoolService: SchoolService
	) {}

	ngOnInit(): void {
		//Load data
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.SchoolID = school.SchoolID;
		});

		// this.loadSchools();
		this.loadStaffType();
		this.loadEthnicity();
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	//////////////////////////////////////
	// Data
	//////////////////////////////////////

	subscription: any;

	user: any;
	SchoolID: any;
	lstSchool: any = [];

	//Form data
	FirstName: any = "";
	MInitial: any = "";
	LastName: any = "";
	Title: any = "";
	DOB: any = new Date();

	Gender: any = "N";
	lstGender: any = [
		{
			ID: "N",
			Desc: "Not Specified",
		},
		{
			ID: "F",
			Desc: "F",
		},
		{
			ID: "M",
			Desc: "M",
		},
	];

	StaffID: any = "";

	StaffType: any;
	lstStaffType: any = [];

	SSN: any = "";

	Ethnicity: any;
	lstEthnicity: any = [];

	Status: any = 1;
	lstStatus: any = [
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	Address1: any = "";
	Address2: any = "";
	City: any = "";
	State: any = "";
	Zip: any = "";
	WPhone: any = "";
	CPhone: any = "";
	HPhone: any = "";
	Fax: any = "";
	Email: any = "";

	errorMessage: any = "";

	//////////////////////////////////////

	//////////////////////////////////////
	// Load Data
	//////////////////////////////////////

	loadSchools() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.SchoolID = this.lstSchool[0].SchoolID;
			},
			(error) => {}
		);
	}

	loadStaffType() {
		var result = this.staffService.StaffTypeSelectList();
		result.subscribe(
			(response) => {
				this.lstStaffType = response;
				this.StaffType = this.lstStaffType[0].PersonTypeID;
			},
			(error) => {}
		);
	}
	loadEthnicity() {
		var result = this.staffService.EthnicitySelectList();
		result.subscribe(
			(response) => {
				this.lstEthnicity = response;
				this.Ethnicity = this.lstEthnicity[0].EthnicityID;
			},
			(error) => {}
		);
	}
	//////////////////////////////////////

	//////////////////////////////////////
	// Buttons
	//////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		////////////////////////////////////
		// Error handling
		////////////////////////////////////

		//Format (phone, fax, etc.)

		//ID in use

		this.CheckBlanks();

		////////////////////////////////////

		//Add Data
		// this.FinishAdd();
	}

	CheckBlanks() {
		if (this.FirstName == "") {
			this.errorMessage = "Enter a first name";
			return;
		}

		if (this.LastName == "") {
			this.errorMessage = "Enter a last name";
			return;
		}

		// if(this.Title == ""){
		//   this.errorMessage = "Enter a job title";
		//   return;
		// }

		if (this.StaffID == "") {
			this.errorMessage = "Enter a staff ID";
			return;
		}

		this.CheckFormat();
	}

	CheckFormat() {
		//Update phone numbers
		this.WPhone = String(this.WPhone).replace("-", "");
		this.HPhone = String(this.HPhone).replace("-", "");
		this.CPhone = String(this.CPhone).replace("-", "");
		this.Zip = String(this.Zip).replace("-", "");

		//Length = 10, no letters

		if (this.WPhone != "" && (this.WPhone.length != 10 || this.ContainsLetters(this.WPhone))) {
			this.errorMessage = "Invalid Work Phone number. System expects ###-###-#### format";
			return;
		}

		if (this.HPhone != "" && (this.HPhone.length != 10 || this.ContainsLetters(this.HPhone))) {
			this.errorMessage = "Invalid Home Phone number. System expects ###-###-#### format";
			return;
		}

		if (this.CPhone != "" && (this.CPhone.length != 10 || this.ContainsLetters(this.CPhone))) {
			this.errorMessage = "Invalid Cell Phone number. System expects ###-###-#### format";
			return;
		}

		if (this.Zip != "" && !this.ValidZip(this.Zip)) {
			this.errorMessage = "Invalid Zip Code. System expects ##### or #####-#### format";
			return;
		}

		//Social Security

		this.CheckStaffID();
	}

	ValidZip(zip) {
		if (this.ContainsLetters(zip)) {
			return false;
		}

		if (zip.length != 5 && zip.length != 9) {
			return false;
		}

		return true;
	}

	ContainsLetters(str) {
		if (str == undefined) {
			return true; //Throw error
		}

		for (var i = 0; i < str.length; i++) {
			var nextChar = String(str).substring(i, i + 1);

			if (isNaN(Number(nextChar))) {
				return true;
			}
		}

		return false;
	}

	CheckStaffID() {
		var result = this.staffService.StaffIDInUse(this.StaffID);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Staff ID already in use";
					return;
				} else {
					this.FinishAdd();
				}
			},
			(error) => {}
		);
	}

	FinishAdd() {
		var DefinedBy: any = this.user.UserLevelID == 1 ? 4 : 3;

		var DateOfBirth: any = "";
		if (this.DOB == null) {
			DateOfBirth = "-1";
		} else {
			DateOfBirth = moment(this.DOB).format("MM/DD/YYYY");
		}

		//Create Parms
		let parms: StaffInsertModel = {
			PersonID: -1,
			LastName: this.LastName,
			FirstName: this.FirstName,
			MiddleInitial: this.MInitial,
			StaffTitle: this.Title,
			StaffID: this.StaffID,
			PersonTypeID: this.StaffType,
			EMail: this.Email, // Added?
			SSN: this.SSN,
			Gender: this.Gender,
			DOB: DateOfBirth, //moment.format
			Street1: this.Address1,
			Street2: this.Address2,
			City: this.City,
			State: this.State,
			Zip: this.Zip,
			HomePhone: this.HPhone,
			CellPhone: this.CPhone,
			WorkPhone: this.WPhone,
			FaxNumber: this.Fax,
			Pager: "", //No longer used?
			Ethnicity: this.Ethnicity,
			Active: this.Status,
			SchoolID: this.SchoolID,
			RaceID: -1, //Not used?
			DefinedByID: DefinedBy,
		};

		var result = this.staffService.StaffInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Staff member was created successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not create the staff member",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////
}
